<template>
  <LoadingSkeletonBase
    class="loader"
    :speed="1"
    :height="350"
  >
    <circle
      cx="45"
      cy="40"
      r="20"
    />
    <rect
      x="100"
      y="15"
      rx="5"
      ry="5"
      class="menu-text"
    />

    <circle
      cx="45"
      cy="140"
      r="20"
    />
    <rect
      x="100"
      y="115"
      rx="5"
      ry="5"
      class="menu-text"
    />

    <circle
      cx="45"
      cy="240"
      r="20"
    />
    <rect
      x="100"
      y="215"
      rx="5"
      ry="5"
      class="menu-text"
    />
  </LoadingSkeletonBase>
</template>

<script>
import LoadingSkeletonBase from '../../../../common/misc/loading-skeleton/base/LoadingSkeletonBase.vue';

export default {
  name: 'MenuLoader',
  components: { LoadingSkeletonBase },
};
</script>

<style lang="scss" scoped>
  .loader {
    width: 100%;

    rect.menu-text {
      width: calc(100% - 125px);
      height: 55px;
    }
  }
</style>
